<template>
  <main-sidebar :name="name" :title="$t('filters')">
    <div class="p-4">
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('client') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.client_id"
            multiple
            :options="clientList"
            class="w-full"
            :reduce="(client) => client.ClientId"
            label="ClientName"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('bank') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.bank_id"
            multiple
            :options="bankList"
            class="w-full"
            :reduce="(bank) => bank.id"
            label="short_name"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('currency') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.currency"
            multiple
            :options="currencyList"
            class="w-full"
            :reduce="(currency) => currency.id"
            label="name"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-checkbox v-model="filters.cash_request">{{
            $t('cash_request')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="success" type="border" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'


export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return false
    },
  },
  data: () => ({
    filters: {
      cash_request: false,
      client_id: [],
      bank_id: [],
      currency: [],
    },
    name: 'bank-account-filter',
    loading: {},
    currencyList: [
      { id: 'MXN', name: 'MXN' },
      { id: 'USD', name: 'USD' },
    ],
  }),
  methods: {
    clear() {
      const defaultFilter = {
        client_id: [],
        bank_id: [],
        currency: [],
        cash_request: false,
      }
      this.filters = Object.assign({}, defaultFilter)
      this.$emit('input', this.filters)
      this.$emit('search')
      this.close()
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {

      this.filters = Object.assign({}, this.value)
    },
    setFilter() {
      this.$emit('input', this.filters)
      this.$emit('search')
      this.close()
    },
  },
  mixins: [loading],
  props: {
    value: {
      type: Object,
      default: () => ({
        client_id: [],
        bank_id: [],
        currency: [],
        cash_request: false,
      }),
    },
    clientList: {
      type: Array,
      default: () => [],
    },
    bankList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
}
</script>

<style>
</style>